<template>
    <div ref="settingsTabItems">
        <TwoFactor></TwoFactor>
	    <RecoveryCodes></RecoveryCodes>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useAppHelpers } from '@/composables/useAppHelpers.js';
import TwoFactor from "@/components/Member/Settings/TwoFactorAuthentication/TwoFactor.vue";
import RecoveryCodes from "@/components/Member/Settings/TwoFactorAuthentication/RecoveryCodes.vue";

const helper = useAppHelpers();
const settingsTabItems = ref(null);

onMounted(() => {
    helper.loaderOn(settingsTabItems.value);
    setTimeout(() => {
        helper.loaderOff(settingsTabItems.value);
    }, 500);
});

</script>

<style lang="scss" scoped>
.password_toggle{
    position: absolute;
    top: 36px; 
    right: 0;
}
</style>